/**
 * @file ProgressBar.jsx
 * @description A reusable progress bar component that renders a MUI LinearProgress
 *              bar alongside a caption label. Accepts a percentage string (e.g. "80%"),
 *              parses it to a numeric value, and clamps it between 0–100.
 *              Displays in blue when progress > 0, grey otherwise.
 *
 * @component ProgressBar
 * @param {string} progressStr - Progress value as a percentage string (e.g. "75%").
 *
 */
import React from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';

function ProgressBar({ progressStr }) {
    // progressStr="80%"
    const numeric = parseFloat(progressStr);
    const value = isNaN(numeric) ? 0 : Math.min(Math.max(numeric, 0), 100);

    return (
        <Box sx={{ minWidth: 100 }}>
            <LinearProgress
                variant="determinate"
                value={value}
                sx={{
                    height: 8,
                    borderRadius: 4,
                    backgroundColor: "#e0e0e0",
                    '& .MuiLinearProgress-bar': {
                        borderRadius: 4,
                        backgroundColor: value > 0 ? "#1976d2" : "#9e9e9e",
                    },
                }}
            />
            <Typography variant="caption" sx={{ color: "text.secondary" }}>
                {progressStr ?? "0%"}
            </Typography>
        </Box>
    );
}

export default ProgressBar;